import { useRecentNumbers, type RecentNumber } from '../../hooks/useRecentNumbers';

interface Props {
  onSelect: (n: RecentNumber) => void;
}

function relative(iso: string): string {
  const days = Math.round((Date.now() - new Date(iso).getTime()) / (24 * 60 * 60 * 1000));
  if (days === 0) return 'vandaag';
  if (days === 1) return 'gisteren';
  return `${days}d geleden`;
}

export function RecentNumbersDropdown({ onSelect }: Props) {
  const { numbers, isLoading } = useRecentNumbers(10);

  if (isLoading) {
    return (
      <div className="p-2 text-xs text-gray-400">Recent laden...</div>
    );
  }
  if (numbers.length === 0) {
    return (
      <div className="p-2 text-xs text-gray-400">Nog geen recente nummers.</div>
    );
  }

  return (
    <ul className="max-h-64 overflow-y-auto divide-y divide-gray-100 border border-gray-200 rounded-md bg-white shadow-sm">
      {numbers.map((n) => (
        <li key={n.to_number}>
          <button
            type="button"
            onClick={() => onSelect(n)}
            className="w-full flex items-center justify-between px-3 py-2 hover:bg-gray-50 text-left"
          >
            <div className="min-w-0">
              <div className="text-sm text-gray-900 truncate">
                {n.last_customer_name ?? n.to_number}
              </div>
              {n.last_customer_name && (
                <div className="text-xs text-gray-500">{n.to_number}</div>
              )}
            </div>
            <div className="flex items-center gap-2 ml-2">
              {n.last_brand && (
                <span className="text-[10px] uppercase tracking-wide px-1.5 py-0.5 rounded bg-gray-100 text-gray-600">
                  {n.last_brand}
                </span>
              )}
              <span className="text-[11px] text-gray-400">{relative(n.last_called_at)}</span>
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
}
